export const getUserApi = async (token, user_id) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}`;
  const requestOptions = {
    method: 'GET',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const updateUserApi = async (token, user_id, params) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}`;

  const data = new FormData();
  if (params.image) {
    data.append('image', params.image);
  }
  if (params.username) {
    data.append('username', params.username);
  }

  const requestOptions = {
    method: 'PUT',
    headers: {
      Authorization: 'Token token=' + token
    },
    body: data //JSON.stringify(params)
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};
